import { IJobTitle } from "../common/data/dtos/job-title";
import { DELETE_TYPED_ASYNC, GET_TYPED_ASYNC, POST_TYPED_ASYNC, PUT_TYPED_ASYNC } from "../helpers/httpHelper";

const BASE_PATH = 'api/JobTitle';

interface JobTitleResponse {
    success: boolean;
    jobTitle?: IJobTitle;
    jobTitles?: IJobTitle[];
    error?: string;
}

type CreateJobTitleType = Omit<IJobTitle, 'id'> | Partial<IJobTitle>;

const createJobTitle = async (jobTitle: CreateJobTitleType): Promise<JobTitleResponse> => {
    try {
        const response = await POST_TYPED_ASYNC<IJobTitle>(`${BASE_PATH}`, jobTitle);
        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const deleteJobTitle= async (id: string): Promise<JobTitleResponse> => {
    try {
        const response = await DELETE_TYPED_ASYNC<IJobTitle>(`${BASE_PATH}/${id}`);

        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const getJobTitles = async (): Promise<JobTitleResponse> => {
    try {
        const response = await GET_TYPED_ASYNC<IJobTitle>(`${BASE_PATH}`);

        if (!response.success) {
            return { success: response.success, error: response.message || response.exception };
        }

        return { success: response.success, jobTitles: response.collection };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const getOneJobTitle = async (id: string): Promise<JobTitleResponse> => {
    try {
        const response = await GET_TYPED_ASYNC<IJobTitle>(`${BASE_PATH}?id=${id}`);

        if (!response.success) {
            return { success: response.success, error: response.message || response.exception };
        }

        return { success: response.success, jobTitle: response.entity };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const updateJobTitle = async (jobTitle: IJobTitle): Promise<JobTitleResponse> => {
    try {
        const response = await PUT_TYPED_ASYNC<IJobTitle>(`${BASE_PATH}/${jobTitle.id}`, jobTitle);
        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

export default {
    createJobTitle,
    deleteJobTitle,
    getJobTitles,
    getOneJobTitle,
    updateJobTitle,
};
